import { getInit } from "./InitBuildAndBuy";
import BuildAndBuyV2 from "./components/lexus/BuildAndBuyV2";

// Webpack entry.
export const init = getInit(BuildAndBuyV2);
